(function() { window.GUID_e56e712b_1ee4_4c63_9cb3_ddcb96a154be = { getGuid: function() { return "e56e712b-1ee4-4c63-9cb3-ddcb96a154be"; } }; })();
var CS;
(function (CS) {
    let VsaUi;
    (function (VsaUi) {
        /**
         * Shared boundary class applied to every new Blazor/Vertical Slice UI root (MVC mount
         * element or standalone WASM host `<body>`). Keep this value in sync with
         * `BlazorMvcHtmlHelper.ModernUiBoundaryCssClass`
         * (Web/CS.Shared.Web/BlazorMvcHost/BlazorMvcHtmlHelper.cs).
         */
        VsaUi.ModernUiBoundaryCssClass = "cs-vsa-ui";
        /** CSS selector matching the modern UI boundary, ready to use with jQuery/`closest`/`querySelector`. */
        VsaUi.ModernUiBoundarySelector = "." + VsaUi.ModernUiBoundaryCssClass;
    })(VsaUi = CS.VsaUi || (CS.VsaUi = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-vsa-ui.js.map
